module.exports = __webpack_public_path__ + "img/backgroundCapa.154acf85.jpg";